import type { DocumentCitations } from '../files/interface';

export interface SearchHistory {
  dossier_id: string;
  history_id: string;
  is_saved: boolean;
  query: string;
  answer: string;
  citations: DocumentCitations;
  username: string;
  created_at: string;
  updated_at: string;
}

export interface Fragment {
  fragment_id: string;
  file_id: string;
  type: string;
  start_page: number;
  end_page: number;
}

export enum SearchType {
  Normal = 'normal',
  Deep = 'deep',
}
